import { createContext, useState, useCallback, useMemo, useContext } from 'react';
import { jsx } from 'react/jsx-runtime';

const extensionsContext = /*#__PURE__*/createContext({
  collectedExtensions: [],
  setCollectedExtensions: () => void 0,
  toggles: [],
  setToggles: () => void 0,
  addExtensionPoint: () => void 0,
  removeExtensionPoint: () => void 0,
  extensionPoints: []
});

function ExtensionsDevtoolsProvider({
  children
}) {
  const [collectedExtensions, setCollectedExtensions] = useState([]);
  const [extensionPoints, setExtensionPoints] = useState([]);
  const [toggles, setToggles] = useState([]);
  const addExtensionPoint = useCallback(extensionPoint => {
    setExtensionPoints(prev => [...prev, extensionPoint]);
  }, []);
  const removeExtensionPoint = useCallback(extensionPoint => {
    setExtensionPoints(extensionPoints => extensionPoints.filter(point => point !== extensionPoint));
  }, []);
  const value = useMemo(() => {
    return {
      collectedExtensions,
      setCollectedExtensions,
      toggles,
      setToggles,
      extensionPoints,
      addExtensionPoint,
      removeExtensionPoint
    };
  }, [collectedExtensions, setCollectedExtensions, toggles, setToggles, addExtensionPoint, extensionPoints, removeExtensionPoint]);
  return /*#__PURE__*/jsx(extensionsContext.Provider, {
    value: value,
    children: children
  });
}

const moduleFederationContext = /*#__PURE__*/createContext({
  aggregatedModules: [],
  addRemotes: () => void 0
});

function ModuleFederationDevtoolsProvider({
  children
}) {
  const [aggregatedModules, setAggregatedModules] = useState([]);
  const addRemotes = useCallback(({
    remotes,
    modules
  }) => {
    const aggregatedModules = [];
    modules.forEach((module, index) => {
      const remote = remotes?.[index];
      for (const [index, singleModule] of module.entries()) {
        if (!singleModule) {
          return;
        }
        const localOverride = sessionStorage.getItem(remote.name) ?? localStorage.getItem(remote.name);
        const remoteURL = localOverride ? localOverride : remote?.source;
        aggregatedModules.push({
          ...singleModule,
          remote: {
            name: remote?.name,
            source: {
              href: remoteURL,
              local: !!localOverride
            },
            import: remote?.imports?.[index]
          }
        });
      }
    });
    setAggregatedModules(prevState => [...prevState.filter(m => !aggregatedModules.some(am => am.name !== m.name)), ...aggregatedModules]);
  }, []);
  const value = useMemo(() => {
    return {
      aggregatedModules,
      addRemotes
    };
  }, [addRemotes, aggregatedModules]);
  return /*#__PURE__*/jsx(moduleFederationContext.Provider, {
    value: value,
    children: children
  });
}

function DevtoolsProvider({
  children
}) {
  return /*#__PURE__*/jsx(ModuleFederationDevtoolsProvider, {
    children: /*#__PURE__*/jsx(ExtensionsDevtoolsProvider, {
      children: children
    })
  });
}

const useModuleFederationDevtools = () => {
  return useContext(moduleFederationContext);
};

const useExtensionsDevtools = () => {
  return useContext(extensionsContext);
};

export { DevtoolsProvider, useExtensionsDevtools, useModuleFederationDevtools };
//# sourceMappingURL=index.js.map
